/**
 * Owns the read-only exemplar overlay for the run RunView has open: the boxes it reports and the
 * per-polarity visibility switches. Visibility lives here rather than in RunView so it carries
 * over when the user moves between runs.
 */

import React from 'react';

import {
  RunExemplarVisibility,
  RunExemplars,
} from 'app/components/AgentExplorer/fewShotExemplarTypes';

export interface RunExemplarsState {
  // Only the polarities whose switch is on.
  visibleRunExemplars: RunExemplars | null;
  handleRunExemplarsChange: (exemplars: RunExemplars | null) => void;
  runExemplarVisibility: RunExemplarVisibility;
  setRunExemplarVisibility: (visibility: RunExemplarVisibility) => void;
  clearRunExemplars: () => void;
}

export default function useRunExemplars(): RunExemplarsState {
  const [runExemplars, setRunExemplars] = React.useState<RunExemplars | null>(null);
  const [runExemplarVisibility, setRunExemplarVisibility] = React.useState<RunExemplarVisibility>({
    positives: true,
    negatives: true,
  });

  const visibleRunExemplars = React.useMemo(
    () =>
      runExemplars && {
        positives: runExemplarVisibility.positives ? runExemplars.positives : [],
        negatives: runExemplarVisibility.negatives ? runExemplars.negatives : [],
      },
    [runExemplars, runExemplarVisibility]
  );

  const clearRunExemplars = React.useCallback(() => setRunExemplars(null), []);

  return {
    visibleRunExemplars,
    handleRunExemplarsChange: setRunExemplars,
    runExemplarVisibility,
    setRunExemplarVisibility,
    clearRunExemplars,
  };
}
